var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "px-3 mb-4 force-bind-modal",
      attrs: { action: "self" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submitBundleForceBind($event)
        }
      }
    },
    [
      _c("hr"),
      _vm._v(" "),
      _c("input-product-type", {
        attrs: { insuranceType: _vm.formFields.insuranceType }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.formFields.insuranceType.field_value !== "",
              expression: "formFields.insuranceType.field_value !== ''"
            }
          ],
          staticClass: "row"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showPropertySection,
                  expression: "showPropertySection"
                }
              ],
              class: {
                "col-6": _vm.halfLayout,
                "col-12": !_vm.halfLayout,
                disabled: _vm.isHomeBound
              }
            },
            [
              _c("h1", [_vm._v(_vm._s(_vm.flow) + " Policy")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "row no-gutters",
                  on: {
                    "!mousedown": function($event) {
                      return _vm.clearMessages(
                        _vm.formFields.forceBindCarrier.field_name
                      )
                    }
                  }
                },
                [
                  _c("div", { staticClass: "col" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "btn-group btn-group-toggle  w-auto smaller-font-content",
                          attrs: { "data-toggle": "buttons", tabindex: "-1" }
                        },
                        [
                          _c("v-select", {
                            ref: _vm.formFields.forceBindCarrier.field_name,
                            staticClass: " w-auto",
                            class: {
                              "std-width form-control": false,
                              error: _vm.formErrors.includes(
                                _vm.formFields.forceBindCarrier.field_name
                              )
                            },
                            attrs: {
                              options: _vm.carriers,
                              label: "carrier_name",
                              name: _vm.formFields.forceBindCarrier.field_name,
                              id: _vm.formFields.forceBindCarrier.field_name,
                              size: "auto",
                              placeholder: "Select One",
                              disabled: _vm.isHomeBound
                            },
                            model: {
                              value:
                                _vm.formFields.forceBindCarrier.field_value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.forceBindCarrier,
                                  "field_value",
                                  $$v
                                )
                              },
                              expression:
                                "formFields.forceBindCarrier.field_value"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("i", {
                        class: {
                          "warning fas fa-exclamation-triangle": _vm.formErrors.includes(
                            _vm.formFields.forceBindCarrier.field_name
                          )
                        }
                      })
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "row no-gutters",
                  on: {
                    "!mousedown": function($event) {
                      return _vm.clearMessages(
                        _vm.formFields.policyNumber.field_name
                      )
                    }
                  }
                },
                [
                  _c("div", { staticClass: "col" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("div", { staticClass: "input-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.formFields.policyNumber.field_value,
                              expression: "formFields.policyNumber.field_value"
                            }
                          ],
                          class: {
                            "form-control": true,
                            error: _vm.formErrors.includes(
                              _vm.formFields.policyNumber.field_name
                            )
                          },
                          attrs: {
                            type: "text",
                            maxlength: "20",
                            disabled: _vm.isHomeBound
                          },
                          domProps: {
                            value: _vm.formFields.policyNumber.field_value
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.formFields.policyNumber,
                                "field_value",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("i", {
                          class: {
                            "warning fas fa-exclamation-triangle": _vm.formErrors.includes(
                              _vm.formFields.policyNumber.field_name
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm._m(2)
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "row no-gutters",
                  on: {
                    "!mousedown": function($event) {
                      return _vm.clearMessages(
                        _vm.formFields.finalPremium.field_name
                      )
                    }
                  }
                },
                [
                  _c("div", { staticClass: "col" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        { staticClass: "input-group" },
                        [
                          _c(
                            "money",
                            _vm._b(
                              {
                                class: {
                                  "form-control": true,
                                  error: _vm.formErrors.includes(
                                    _vm.formFields.finalPremium.field_name
                                  )
                                },
                                attrs: {
                                  maxlength: "9",
                                  disabled: _vm.isHomeBound
                                },
                                model: {
                                  value:
                                    _vm.formFields.finalPremium.field_value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.finalPremium,
                                      "field_value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.finalPremium.field_value"
                                }
                              },
                              "money",
                              _vm.money,
                              false
                            )
                          ),
                          _vm._v(" "),
                          _c("i", {
                            class: {
                              "warning fas fa-exclamation-triangle": _vm.formErrors.includes(
                                _vm.formFields.finalPremium.field_name
                              )
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(4)
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "row no-gutters",
                  on: {
                    "!mousedown": function($event) {
                      return _vm.clearMessages(
                        _vm.formFields.effectiveDate.field_name
                      )
                    }
                  }
                },
                [
                  _c("div", { staticClass: "col" }, [
                    _vm._m(5),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        { staticClass: "input-group" },
                        [
                          _c("datepicker", {
                            staticStyle: { width: "6rem" },
                            attrs: {
                              "bootstrap-styling": true,
                              typeable: true,
                              format: "MM/dd/yyyy",
                              placeholder: "MM/DD/YYYY",
                              "input-class": {
                                error: _vm.formErrors.includes(
                                  _vm.formFields.effectiveDate.field_name
                                )
                              },
                              disabled: _vm.isHomeBound
                            },
                            on: {
                              opened: function($event) {
                                return _vm.clearDateErrors()
                              }
                            },
                            model: {
                              value: _vm.formFields.effectiveDate.field_value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.effectiveDate,
                                  "field_value",
                                  $$v
                                )
                              },
                              expression: "formFields.effectiveDate.field_value"
                            }
                          }),
                          _vm._v(" "),
                          _c("i", {
                            class: {
                              "warning fas fa-exclamation-triangle": _vm.formErrors.includes(
                                _vm.formFields.effectiveDate.field_name
                              )
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showAutoSection,
                  expression: "showAutoSection"
                }
              ],
              class: {
                "col-6": _vm.halfLayout,
                "col-12": !_vm.halfLayout,
                disabled: _vm.isAutoBound
              }
            },
            [
              _c("h1", [_vm._v("Auto Policy")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "row no-gutters",
                  on: {
                    "!mousedown": function($event) {
                      return _vm.clearMessages(
                        _vm.formFields.forceBindCarrierAuto.field_name
                      )
                    }
                  }
                },
                [
                  _c("div", { staticClass: "col" }, [
                    _vm._m(6),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "btn-group btn-group-toggle  w-auto smaller-font-content",
                          attrs: { "data-toggle": "buttons", tabindex: "-1" }
                        },
                        [
                          _c("v-select", {
                            ref: _vm.formFields.forceBindCarrierAuto.field_name,
                            staticClass: " w-auto",
                            class: {
                              "std-width form-control": false,
                              error: _vm.formErrors.includes(
                                _vm.formFields.forceBindCarrierAuto.field_name
                              )
                            },
                            attrs: {
                              options: _vm.autoCarriers,
                              label: "carrier_name",
                              name:
                                _vm.formFields.forceBindCarrierAuto.field_name,
                              id:
                                _vm.formFields.forceBindCarrierAuto.field_name,
                              size: "auto",
                              placeholder: "Select One",
                              disabled: _vm.isAutoBound
                            },
                            model: {
                              value:
                                _vm.formFields.forceBindCarrierAuto.field_value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.forceBindCarrierAuto,
                                  "field_value",
                                  $$v
                                )
                              },
                              expression:
                                "formFields.forceBindCarrierAuto.field_value"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("i", {
                        class: {
                          "warning fas fa-exclamation-triangle": _vm.formErrors.includes(
                            _vm.formFields.forceBindCarrierAuto.field_name
                          )
                        }
                      })
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "row no-gutters",
                  on: {
                    "!mousedown": function($event) {
                      return _vm.clearMessages(
                        _vm.formFields.policyNumberAuto.field_name
                      )
                    }
                  }
                },
                [
                  _c("div", { staticClass: "col" }, [
                    _vm._m(7),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("div", { staticClass: "input-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.formFields.policyNumberAuto.field_value,
                              expression:
                                "formFields.policyNumberAuto.field_value"
                            }
                          ],
                          class: {
                            "form-control": true,
                            error: _vm.formErrors.includes(
                              _vm.formFields.policyNumberAuto.field_name
                            )
                          },
                          attrs: {
                            type: "text",
                            maxlength: "20",
                            disabled: _vm.isAutoBound
                          },
                          domProps: {
                            value: _vm.formFields.policyNumberAuto.field_value
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.formFields.policyNumberAuto,
                                "field_value",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("i", {
                          class: {
                            "warning fas fa-exclamation-triangle": _vm.formErrors.includes(
                              _vm.formFields.policyNumberAuto.field_name
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm._m(8)
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "row no-gutters",
                  on: {
                    "!mousedown": function($event) {
                      return _vm.clearMessages(
                        _vm.formFields.finalPremiumAuto.field_name
                      )
                    }
                  }
                },
                [
                  _c("div", { staticClass: "col" }, [
                    _vm._m(9),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        { staticClass: "input-group" },
                        [
                          _c(
                            "money",
                            _vm._b(
                              {
                                class: {
                                  "form-control": true,
                                  error: _vm.formErrors.includes(
                                    _vm.formFields.finalPremiumAuto.field_name
                                  )
                                },
                                attrs: {
                                  maxlength: "9",
                                  disabled: _vm.isAutoBound
                                },
                                model: {
                                  value:
                                    _vm.formFields.finalPremiumAuto.field_value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.finalPremiumAuto,
                                      "field_value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.finalPremiumAuto.field_value"
                                }
                              },
                              "money",
                              _vm.money,
                              false
                            )
                          ),
                          _vm._v(" "),
                          _c("i", {
                            class: {
                              "warning fas fa-exclamation-triangle": _vm.formErrors.includes(
                                _vm.formFields.finalPremiumAuto.field_name
                              )
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(10)
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "row no-gutters",
                  on: {
                    "!mousedown": function($event) {
                      return _vm.clearMessages(
                        _vm.formFields.termLength.field_name
                      )
                    }
                  }
                },
                [
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(11),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "input-group field-input-radio" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "btn-group btn-group-toggle",
                              class: {
                                error: _vm.formErrors.includes(
                                  _vm.formFields.termLength.field_name
                                )
                              },
                              attrs: {
                                "data-toggle": "buttons",
                                disabled: _vm.isAutoBound
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "btn btn-outline-light",
                                  class: {
                                    active:
                                      _vm.formFields.termLength.field_value ===
                                      "12Month"
                                        ? true
                                        : false
                                  }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.formFields.termLength.field_value,
                                        expression:
                                          "formFields.termLength.field_value"
                                      }
                                    ],
                                    attrs: {
                                      name: "termLength",
                                      id: "term-12-mo-radio",
                                      type: "radio",
                                      value: "12Month",
                                      disabled: _vm.isAutoBound
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.formFields.termLength.field_value,
                                        "12Month"
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.$set(
                                          _vm.formFields.termLength,
                                          "field_value",
                                          "12Month"
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "cursorBox",
                                      attrs: { for: "term-12-mo-radio" }
                                    },
                                    [_vm._v("12 months")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "btn btn-outline-light",
                                  class: {
                                    active:
                                      _vm.formFields.termLength.field_value ===
                                      "6Month"
                                        ? true
                                        : false
                                  }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.formFields.termLength.field_value,
                                        expression:
                                          "formFields.termLength.field_value"
                                      }
                                    ],
                                    attrs: {
                                      name: "termLength",
                                      id: "term-6-mo-radio",
                                      type: "radio",
                                      value: "6Month",
                                      disabled: _vm.isAutoBound
                                    },
                                    domProps: {
                                      checked: _vm._q(
                                        _vm.formFields.termLength.field_value,
                                        "6Month"
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.$set(
                                          _vm.formFields.termLength,
                                          "field_value",
                                          "6Month"
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "cursorBox",
                                      attrs: { for: "term-6-mo-radio" }
                                    },
                                    [_vm._v("6 months")]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            class: {
                              "warning fas fa-exclamation-triangle": _vm.formErrors.includes(
                                _vm.formFields.termLength.field_name
                              )
                            }
                          })
                        ]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "row no-gutters",
                  on: {
                    "!mousedown": function($event) {
                      return _vm.clearMessages(
                        _vm.formFields.effectiveDateAuto.field_name
                      )
                    }
                  }
                },
                [
                  _c("div", { staticClass: "col" }, [
                    _vm._m(12),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        { staticClass: "input-group" },
                        [
                          _c("datepicker", {
                            staticStyle: { width: "6rem" },
                            attrs: {
                              "bootstrap-styling": true,
                              typeable: true,
                              format: "MM/dd/yyyy",
                              placeholder: "MM/DD/YYYY",
                              "input-class": {
                                error: _vm.formErrors.includes(
                                  _vm.formFields.effectiveDateAuto.field_name
                                )
                              },
                              disabled: _vm.isAutoBound
                            },
                            on: {
                              opened: function($event) {
                                return _vm.clearDateErrors()
                              }
                            },
                            model: {
                              value:
                                _vm.formFields.effectiveDateAuto.field_value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.effectiveDateAuto,
                                  "field_value",
                                  $$v
                                )
                              },
                              expression:
                                "formFields.effectiveDateAuto.field_value"
                            }
                          }),
                          _vm._v(" "),
                          _c("i", {
                            class: {
                              "warning fas fa-exclamation-triangle": _vm.formErrors.includes(
                                _vm.formFields.effectiveDateAuto.field_name
                              )
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _vm._m(13),
      _vm._v(" "),
      _vm.namedInsuredStatus()
        ? _c(
            "button",
            {
              staticClass: "btn btn-primary d-block mx-auto",
              attrs: { type: "submit", id: "force-bind-submit-button" }
            },
            [_vm._v("Force Bind Policy")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Binding Carrier "),
      _c("span", { staticClass: "required-red" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Policy Number"),
      _c("span", { staticClass: "required-red" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-subtext pr-2" }, [
      _c("div", { staticClass: "form-text smaller-font-content" }, [
        _vm._v("20 Character Maximum")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Total Premium"),
      _c("span", { staticClass: "required-red" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-subtext pr-2" }, [
      _c("div", { staticClass: "form-text smaller-font-content" }, [
        _vm._v("7 Digit Maximum ($XXXXX.XX)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Policy Effective Date"),
      _c("span", { staticClass: "required-red" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Binding Carrier "),
      _c("span", { staticClass: "required-red" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Policy Number"),
      _c("span", { staticClass: "required-red" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-subtext pr-2" }, [
      _c("div", { staticClass: "form-text smaller-font-content" }, [
        _vm._v("20 Character Maximum")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Total Premium"),
      _c("span", { staticClass: "required-red" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-subtext pr-2" }, [
      _c("div", { staticClass: "form-text smaller-font-content" }, [
        _vm._v("7 Digit Maximum ($XXXXX.XX)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("label", [
        _vm._v("Policy Term"),
        _c("span", { staticClass: "required-red" }, [_vm._v("*")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Policy Effective Date"),
      _c("span", { staticClass: "required-red" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "d-block justify-content-center mx-auto my-3" },
      [
        _c(
          "div",
          {
            staticClass: "alert alert-warning mx-3 my-0 py-2",
            attrs: { role: "alert" }
          },
          [
            _c("div", { staticClass: "row no-gutters" }, [
              _c("div", { staticClass: "d-inline-block pr-2 my-auto" }, [
                _c("img", {
                  attrs: {
                    width: "25px",
                    height: "25px",
                    src: require("../../assets/exclamation-circle-yellow-new.svg"),
                    alt: "info"
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col smaller-font-content d-inline-block my-auto"
                },
                [
                  _c("p", { staticClass: "mb-0" }, [
                    _vm._v(
                      "Advise the customer of the next steps including that they must sign the application to\n            avoid a premium increase or cancellation."
                    )
                  ])
                ]
              )
            ])
          ]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e8e3063e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8e3063e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/shared/BundleForceBindModal.vue
// module id = null
// module chunks = 